var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    id: "Announcement-Megaphone--Streamline-Plump.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Announcement Megaphone Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Announcement-Megaphone--Streamline-Plump.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2506",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m42.5 19 -3 0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2507",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.5 19 3 0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2507_2",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.5 2v3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2507_3",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.479 6.98 2.12 2.122",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2507_4",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m37.52 6.98 -2.122 2.122",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.811 12.427c-8.819 7.698 -18.314 17.38 -21.687 20.87 -0.79 0.817 -1.042 2.008 -0.587 3.048 0.248 0.565 0.541 1.182 0.844 1.707 0.303 0.525 0.691 1.087 1.057 1.584 0.672 0.915 1.83 1.291 2.932 1.016 4.709 -1.177 17.842 -4.558 28.918 -8.346",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.612 17.193s2.091 2.092 5.636 8.232c3.546 6.14 4.311 8.997 4.311 8.997",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 21",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.696 37.357 0.594 2.218a4.59 4.59 0 1 1 -8.87 2.376l-0.494 -1.848",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#3f77f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.046 11.1s2.397 2.621 7.166 10.882c4.77 8.26 5.841 11.647 5.841 11.647",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/integration-icon.d33b046c9b1472554ca82c5aad4c7175.svg";
export { ForwardRef as ReactComponent };